import { Directive, ElementRef, HostListener, OnDestroy } from '@angular/core';

@Directive({
  selector: '[appScrollOnFocus]',
  standalone: true,
})
export class ScrollOnFocusDirective implements OnDestroy {
  private resizeHandler: () => void;

  constructor(private el: ElementRef<HTMLElement>) {}

  @HostListener('ionFocus')
  onFocus() {
    this.resizeHandler = () => this.scrollIntoView();
    window.visualViewport?.addEventListener('resize', this.resizeHandler);
  }

  @HostListener('ionBlur')
  onBlur() {
    window.visualViewport?.removeEventListener('resize', this.resizeHandler);
  }

  private scrollIntoView() {
    const keyboardHeight = window.innerHeight - (window.visualViewport?.height ?? window.innerHeight);
    if (keyboardHeight < 100) {return;}

    const itemRect = (this.el.nativeElement.closest('ion-item') ?? this.el.nativeElement).getBoundingClientRect();
    const visibleBottom = (window.visualViewport?.height ?? window.innerHeight) - 16;

    if (itemRect.bottom > visibleBottom) {
      const contentEl = this.el.nativeElement.closest('ion-content') as any;
      contentEl?.scrollByPoint(0, itemRect.bottom - visibleBottom, 300);
    }
  }

  ngOnDestroy() {
    window.visualViewport?.removeEventListener('resize', this.resizeHandler);
  }
}
